import {
  SOFTWARE_PAGE_VIEWED_COOKIE,
  SQUARE_ONE_PNP_COOKIE,
  SQUARE_ONE_BUCKETED_VALUE,
} from 'constants/cookies';
import Cookies from 'js-cookie';

export const getSoftwarePageViewed = () => {
  const cookieValue = Cookies.get(SOFTWARE_PAGE_VIEWED_COOKIE);
  return cookieValue === 'true';
};

export const checkForSquareOneExperiment = () => {
  const cookieValue = Cookies.get(SQUARE_ONE_PNP_COOKIE);

  // if they are in the experiment, the value will be 'square-one-group-v1'
  // if not, it is an empty string
  return cookieValue === SQUARE_ONE_BUCKETED_VALUE;
};
